var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMarion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 28,
    viewBox: "0 0 117 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1467_2757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18.6929C0 13.4429 4.46791 9.875 9.00975 9.875C11.8827 9.875 14.1853 10.925 15.7803 12.7036C17.4491 10.925 19.9207 9.875 22.3923 9.875C27.5679 9.875 31.2437 13.4321 31.2437 18.6929V27.1036H26.7758V18.6929C26.7758 16.025 24.864 14.0857 22.3078 14.0857C19.7517 14.0857 17.8399 16.025 17.8399 18.6929V27.1036H13.372V18.6929C13.372 16.025 11.5342 14.0857 8.90413 14.0857C6.27408 14.0857 4.43622 16.025 4.43622 18.6929V27.1036H0V18.6929Z",
    fill: "#00407C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9104 16.5822C56.9104 12.8643 59.5404 10.2715 63.1317 10.2715H64.7266V14.4715H63.4485C62.255 14.4715 61.3783 15.2751 61.3783 16.5715V27.0822H56.9104V16.5715V16.5822Z",
    fill: "#00407C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0111 6.08214C72.5216 6.08214 73.7257 4.78571 73.7257 3.25357C73.7257 1.72143 72.5321 0.5 71.0111 0.5C69.4902 0.5 68.2227 1.71071 68.2227 3.25357C68.2227 4.79643 69.5007 6.08214 71.0111 6.08214Z",
    fill: "#FF1F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1659 10.2822H68.698V27.1037H73.1659V10.2822Z",
    fill: "#00407C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7817 18.6929C77.7817 13.8393 81.9222 9.875 86.707 9.875C91.8826 9.875 95.6322 13.4321 95.6322 18.6929C95.6322 23.5464 91.4918 27.5107 86.707 27.5107C81.5208 27.5107 77.7817 23.9536 77.7817 18.6929ZM91.1749 18.6929C91.1749 16.025 89.337 14.0857 86.707 14.0857C84.0769 14.0857 82.2391 16.025 82.2391 18.6929C82.2391 21.3607 84.1509 23.3 86.707 23.3C89.2631 23.3 91.1749 21.275 91.1749 18.6929Z",
    fill: "#00407C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1495 18.6929C99.1495 13.4429 103.617 9.875 108.159 9.875C113.335 9.875 117.011 13.4321 117.011 18.6929V27.1036H112.543V18.6929C112.543 16.025 110.705 14.0857 108.075 14.0857C105.445 14.0857 103.607 16.025 103.607 18.6929V27.1036H99.1389V18.6929H99.1495Z",
    fill: "#00407C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1435 10.2821V10.925C46.8549 10.25 45.3339 9.875 43.6756 9.875C38.8908 9.875 34.7504 13.8393 34.7504 18.6929C34.7504 23.9429 38.2571 27.5107 43.2742 27.5107C45.3022 27.5107 47.0978 26.8143 48.1435 25.7214V27.1143H52.6114V10.2929H48.1435V10.2821ZM43.6756 23.3C41.1301 23.3 39.2077 21.275 39.2077 18.6929C39.2077 16.1107 41.1195 14.0857 43.6756 14.0857C46.2317 14.0857 48.1435 16.025 48.1435 18.6929C48.1435 21.3607 46.3057 23.3 43.6756 23.3Z",
    fill: "#00407C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1467_2757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 27,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMarion);
export default __webpack_public_path__ + "static/media/LogoMarion.ae04df47107ac7502fbb9356e93a0054.svg";
export { ForwardRef as ReactComponent };